import { AppState } from '../../../types';

export const isOpen = (state: AppState): boolean => state.modal.isOpen;
